export default {
      id: "vague_organiser_c-usage",
      viewBox: "0 0 800 540",
      url: "../dist/images/" + "sprite.svg#vague_organiser_c-usage",
      toString: function () {
        return this.url;
      }
    }